export const BookmarkedContentListSwrFetchKey = "bookmarkedContentList";
